import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { SoftButton, cls, useDialogPaperSx } from "../../hatim/soft/SoftKit";
import useMemberGoalEditor from "../../goals/useMemberGoalEditor";
import GoalListRow from "../../goals/GoalListRow";

/**
 * Yöneticinin bir üyenin grup hedeflerini düzenlediği pencere. Ekleme ve
 * düzenleme takip ayarlı hedef sihirbazıyla (birim, biçim, eser, plan).
 */
export default function EditUserGoalsModal({ open, groupId, member, onClose }) {
  const { t } = useScriptMode();
  const paperSx = useDialogPaperSx();
  const editor = useMemberGoalEditor({ groupId, member });

  // Sihirbaz çekmecesi pencerenin dışında (body'de) açılıyor; odak kilidi
  // kapalı ki çekmecedeki alanlara yazılabilsin.
  return (
    <>
      <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ sx: paperSx }} disableEnforceFocus>
        <DialogTitle sx={{ fontWeight: 600 }}>
          {t("manage_goals_modal_title").replace(/\{name\}/g, editor.targetName)}
        </DialogTitle>
        <DialogContent sx={{ px: 0 }}>
          {editor.goals.length === 0 ? (
            <p className={`px-6 py-2 text-sm ${cls.muted}`}>{t("manage_goals_empty")}</p>
          ) : (
            <ul>
              {editor.goals.map((goal) => (
                <GoalListRow
                  key={`${goal.label}::${goal.activity || "okuma"}`}
                  goal={goal}
                  busy={editor.busy}
                  onEdit={() => editor.openEdit(goal)}
                  onDelete={() => editor.askDelete(goal)}
                />
              ))}
            </ul>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <SoftButton tone="soft" onClick={onClose}>
            {t("manage_goals_close")}
          </SoftButton>
          <SoftButton tone="primary" onClick={editor.openAdd} disabled={editor.busy}>
            {t("manage_goals_add_cta")}
          </SoftButton>
        </DialogActions>
      </Dialog>
      {editor.elements}
    </>
  );
}
